/**
 * @file AdUnitRowSlot.tsx
 *
 * @fileoverview Renders row ad unit.
 *  This ad banner occupied the full width.
 */

import Spacing from '~/vcl/atoms/06-layout/07-spacing';
import React from 'react';
import AdnuntiusLeaderboardBannerAd from '~/components/AdnuntiusAdsScript/AdnuntiusLeaderboardBannerAd';
import AdnuntiusMpu1BannerAd from '~/components/AdnuntiusAdsScript/AdnuntiusMpu1BannerAd';
import AdnuntiusMpu2BannerAd from '~/components/AdnuntiusAdsScript/AdnuntiusMpu2BannerAd';
import FlexItems from '~/vcl/atoms/06-layout/03-flex';
import FlexItem from '~/vcl/atoms/06-layout/03-flex/02-flex-item';

interface AdUnitRowSlotProps {
  row: {
    bundle?: string;
    adUnitId?: string;
  };
}

export default function AdUnitRowSlot({
  row: { bundle, adUnitId },
}: AdUnitRowSlotProps) {
  switch (adUnitId) {
    case 'leaderboard':
      return (
        <Spacing
          marginTop={0}
          marginBottom={0}
          paddingTop={8}
          paddingBottom={8}
        >
          <AdnuntiusLeaderboardBannerAd />
        </Spacing>
      );
    case 'block':
      return (
        <Spacing
          marginTop={0}
          marginBottom={0}
          paddingTop={8}
          paddingBottom={8}
        >
          <FlexItems flexDirection={'row'} gap={10} justifyContent="center">
            <FlexItem marginLeft={8} marginRight={8}>
              <AdnuntiusMpu1BannerAd />
            </FlexItem>
            <FlexItem marginLeft={8} marginRight={8}>
              <AdnuntiusMpu2BannerAd />
            </FlexItem>
          </FlexItems>
        </Spacing>
      );
    default:
      return null;
  }
}

export { AdUnitRowSlot };
